<div class="modal-header " [ngClass]="classColor">
  <div class="col-12">
      <!--<h4 class="modal-title pull-center fontWhite">{{"17"|translate}}: <b>{{searchVal}}</b></h4>-->
      <!--<h4 *ngIf="verTag"   class="modal-title pull-center fontWhite">{{"17"|translate}}: <b>{{searchVal}}</b></h4>-->
      <h4 class="modal-title pull-center fontWhite">{{ searchTitle|translate}}: <b>{{searchVal}}</b></h4>
      <button type="button" class="close pull-right fontWhite" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true" class="fontWhite">&times;</span>
      </button>
  </div>
</div>
<div class="modal-body fontWhite" [ngClass]="classColor">

  <div *ngIf="data.status == 3" class="col-2 text-center">
    <i class="fa fa-warning fontWhite xlargeIcon"></i>
  </div>
  <div *ngIf="data.status != 3" class="col-2 text-center">
    <i class="fa fa-phone-square fontWhite xlargeIcon"></i>
  </div>
  <div class="col-12 text-center fontWhite">
    <h3 class="modal-title fontWhite">{{TagStatus|translate}}</h3>
    <div class="blog-post" innerHtml="{{TagStatusMessage|translate}}"></div>
  </div>
</div>
<div class="modal-footer" [ngClass]="classColor">

  <!--<button *ngIf="data?.btCancel" type="button" class="btn btn-default" (click)="cancel()" >Cancel</button>-->
  <button type="button" class="btn btn-default btn-cons" (click)="clickOk()" >Ok</button>
</div>
